// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {getDecodedLayouts, stripInvalidLayouts} from '../../../shared/services/get-decoded-layouts';
import actions from '../../actions-list';
import {getDefaultReportLayout} from '../../../reports/shared/services/report-variant';
import {getDefaultState as getDefaultReportLayoutState} from '@deere/cps-it.warranty-model-factory/lib/report-layout';
import {getDefaultState as getLayoutDefaultState} from '@deere/cps-it.warranty-model-factory/lib/report-layout-column-state';
import {getReportLayout} from '../../shared/repositories';

export const updateGridLayouts = (layouts, columnDefs) => dispatch => {

    const updatedNewColumns = layouts.map(layout => {

        const isLayoutMissingNewColumns = layout.name && (layout.columnState.length !== columnDefs.length);

        if (isLayoutMissingNewColumns) {

            const columnNames = layout.columnState.reduce((columnIds, currentColumn) => [...columnIds, currentColumn.colId], []);

            const newColumnsToAdd = columnDefs.reduce((array, currentDef) => {

                if (!columnNames.includes(currentDef.colId)) {

                    return [...array, {
                        ...getLayoutDefaultState(),
                        colId: currentDef.colId,
                        hide: true,
                        width: currentDef.width
                    }];

                }

                return array;

            }, []);

            return {...layout, columnState: [...layout.columnState, ...newColumnsToAdd]};

        }

        return layout;

    });

    const selectedLayout = updatedNewColumns.find(column => column.isDefault);

    dispatch({
        data: updatedNewColumns,
        selectedLayout,
        type: actions.UPDATE_REPORT_GRID_LAYOUTS
    });

};

export const updateDefaultLayout = (columnState, sortModel) =>

    dispatch => {

        dispatch({
            columnState,
            sortModel,
            type: actions.UPDATE_DEFAULT_REPORT_LAYOUT
        });

    };

export const updateReportProperty = (property, value) =>

    dispatch => {

        dispatch({
            property,
            type: actions.UPDATE_REPORT_GRID_LAYOUT_PROPERTY,
            value
        });

    };

const setSelectedLayout = (params, dispatch) => {

    if (params.selectedLayout) {

        params.gridColumnApi.setColumnState(params.selectedLayout.columnState);
        params.gridApi.setSortModel(params.selectedLayout.sortModel);
        params.gridApi.setFilterModel(params.selectedLayout.filterModel);

    } else {

        const defaultReportLayout = getDefaultReportLayout(params.defaultColumnState, params.defaultSortModel);

        updateReportProperty('selectedLayout', defaultReportLayout)(dispatch);

    }

};

/* eslint-disable complexity, max-depth*/

export const getReportLayouts = (reportName, gridColumnApi, gridApi, reportVariantParams) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const response = await getReportLayout(reportName);

            const validLayouts = stripInvalidLayouts(response);

            const layouts = getDecodedLayouts(validLayouts);

            const defaultLayout = layouts.find(layout => layout.isDefault);

            const selectedLayout = defaultLayout ?
                defaultLayout :
                null;

            dispatch({
                data: [getDefaultReportLayoutState(), ...layouts],
                selectedLayout,
                type: actions.UPDATE_REPORT_GRID_LAYOUTS
            });

            if (reportName === 'claim-reimbursement-summary' || reportName === 'reimbursement-summary-details') {

                let defaultColumnState,
                    defaultSortModel;

                if (reportVariantParams.selectedLayout && reportVariantParams.selectedLayout.name && !reportVariantParams.isInitialLoad) {

                    const defaultLayoutObject = reportVariantParams.layouts.find(layout => !layout.name);

                    defaultColumnState = defaultLayoutObject.columnState;
                    defaultSortModel = defaultLayoutObject.sortModel;

                } else {

                    defaultColumnState = gridColumnApi.getColumnState();
                    defaultSortModel = gridApi.getSortModel();

                    updateReportProperty('isInitialLoad', false)(dispatch);

                }

                updateDefaultLayout(defaultColumnState, defaultSortModel)(dispatch);

                const params = {
                    defaultColumnState,
                    defaultSortModel,
                    gridApi,
                    gridColumnApi,
                    selectedLayout
                };

                setSelectedLayout(params, dispatch);

            }

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

/* eslint-enable complexity, max-depth*/

export const resetReportVariant = () => ({
    type: actions.RESET_REPORT_VARIANT
});

export const updateReportColumnsVisibility = isVisible => ({
    isVisible,
    type: actions.TOGGLE_REPORT_COLUMNS_VISIBILITY
});

export const showReportColumn = (columnIndex, colId) => ({
    colId,
    columnIndex,
    type: actions.SHOW_REPORT_COLUMN
});

export const hideReportColumn = columnState => ({
    columnState,
    type: actions.HIDE_REPORT_COLUMN
});



// WEBPACK FOOTER //
// ./src/reports/shared/action-creators/report-variant.js